import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { InfoService } from '../_services/info.service';
import { GlobalService } from 'src/app/_services/global.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { SCHOOL_NAME_PATTERN } from './school-name-pattern';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { AmplitudeService } from 'src/app/_services/amplitude.service';
import { CountryService } from 'src/app/_services/country.service';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { Subject, take, takeUntil } from 'rxjs';
import { TimeZoneService } from 'src/app/_services/time-zone.service';
import json2formdata from 'json2formdata';


declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-school-info',
  templateUrl: './school-info.component.html',
  styleUrls: ['./school-info.component.scss']
})
export class SchoolInfoComponent implements OnInit {
  // this page's own file input — never look it up by id, the profile modal lives in
  // the layout with the same id and getElementById would hand us whichever is first
  @ViewChild('fileUploadInput') fileUploadInput: ElementRef<HTMLInputElement>;

  schoolObject;
  loading = false;
  mode = "view";
  schoolForm: UntypedFormGroup;
  imageFile;
  image;
  mapControls;
  selectedImage;
  overviewData;
  currLang;
  errorsData;
  loginAs;
  toggleMapSearch = false;
  // schoolClosingTimeError;
  weekDays: any[] = [];
  isDaySelected = false;
  weekDaysTip = false;
  countries = [];
  destroy$ = new Subject<void>(); 

  constructor(
    private infoService: InfoService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private errorMsgService: ErrorMsgService,
    private dataService: DataService,
    private router: Router,
    private amplitudesService: AmplitudeService,
    private countryService: CountryService,
    private timeZoneService:TimeZoneService) {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)school-info_(f)getLang_(L)56' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    this.countries = this.countryService.countries;
    // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component 
    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    this.loginAs = localStorage.getItem('loginAs');
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)school-info_(f)getLang_(L)70' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
      // this.schoolClosingTimeError="";
    });
    this.weekDays = [
      {
        name: 'Sunday',
        isSelected: false,
      },
      {
        name: 'Monday',
        isSelected: false,
      },
      {
        name: 'Tuesday',
        isSelected: false,
      },
      {
        name: 'Wednesday',
        isSelected: false,
      },
      {
        name: 'Thursday',
        isSelected: false,
      },
      {
        name: 'Friday',
        isSelected: false,
      },
      {
        name: 'Saturday',
        isSelected: false,
      },
    ];
    this.createSchoolForm();
    this.getSchoolInfo();
  }

  getSchoolInfo() {
    this.loading = true;
    this.dataService.getSchoolInfo().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)school-info_(f)getSchoolInfo_(L)112' , res);
      let selectedSchoolId = localStorage.getItem('schoolId');
      this.schoolObject = res.find(school=> school.id == selectedSchoolId);      
      this.setSelectedWeekDays(this.schoolObject?.attendance_week_days)
      this.schoolForm.setValue(this.extractSchoolData(this.schoolObject));      
      let yellowCircle = {
        lat: this.schoolObject.lat,
        long: this.schoolObject.long,
        color: 'yellow',
        radius: this.schoolObject.zone,
      }
      this.setMapData();
      this.getSchoolStat();
    });
  }
  getSchoolStat() {
    this.infoService.getSchoolStat().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)school-info_(f)getSchoolStat_(L)129' , res);
      this.setOverviewData(res.errors ? res.errors : {},
        res.staff,
        res.students.students_count,
        res.students.parents_count,
        res.gates_count);
      this.loading = false;
    });
  }
  createSchoolForm() {
    this.schoolForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required, Validators.pattern(SCHOOL_NAME_PATTERN)]),
      school_code: new UntypedFormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 ]{1,}$")]),
      email: new UntypedFormControl('', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      country_code: new UntypedFormControl('', [Validators.required]),
      phone: new UntypedFormControl('', [Validators.required, Validators.pattern("^[0-9]{1,20}$")]),
      zone: new UntypedFormControl('', [Validators.required, Validators.pattern("[0-9]*")]),
      // if the format is wrong the field value is "" empty string , so using custom validator to return an error if this is the case
      school_closing_time: new UntypedFormControl(''),
      last_estimated_pickup_time_for_early_dismissal_requests: new UntypedFormControl(''),
      // last_time_to_receive_early_pickup_requests: new UntypedFormControl(0),
      buffer_time_to_receive_early_pickup_requests: new UntypedFormControl(0),
      queue_buffer_time: new UntypedFormControl(0),
    },{ updateOn: 'submit' });
  }
  extractSchoolData(res) {
    let extractedData = {};
    extractedData["name"] = res["name"];
    extractedData["school_code"] = null;
    if (res["codes"].length) {
      extractedData["school_code"] = res["codes"][0].code;
    }
    extractedData["email"] = res["email"];
    extractedData["country_code"] = res["country_code"];
    extractedData["phone"] = res["phone"];
    extractedData["zone"] = res["zone"];
    // extractedData["school_closing_time"] = new Date(res["school_closing_time"]).getUTCHours() + ':' + new Date(res["school_closing_time"]).getUTCMinutes();
    extractedData["school_closing_time"] = this.timeZoneService.convertToLocalTime(res["school_closing_time"],"HH:mm" , "HH:mm") ;
    extractedData["last_estimated_pickup_time_for_early_dismissal_requests"] = this.timeZoneService.convertToLocalTime(res["last_estimated_pickup_time_for_early_dismissal_requests"],"HH:mm" , "HH:mm") ;
    // extractedData["last_time_to_receive_early_pickup_requests"] = res["last_time_to_receive_early_pickup_requests"];
    extractedData["buffer_time_to_receive_early_pickup_requests"] = !!res["buffer_time_to_receive_early_pickup_requests"] ? res["buffer_time_to_receive_early_pickup_requests"]:0;
    extractedData["queue_buffer_time"] = !!res["queue_buffer_time"] ? res["queue_buffer_time"]:0;
    this.image = environment.img_url + res.image_path;

    return extractedData;
  }
  editSchoolData() {
    this.toggleMapSearch = true;
    this.mode = "edit";
    this.amplitudesService.trackEvent('CTA.Edit_School_Info',{})
  }
  getFormValidation(control: string) {
    let errorMSG;
    if (this.schoolForm.controls[control].errors) {
      // errorMSG = this.schoolForm.controls[control].errors.required ? `${control.includes('_') ? control.replace('_', ' ') : control} is required`
      //   : `${control.includes('_') ? control.replace('_', ' ') : control} is invalid`;
      errorMSG = this.schoolForm.controls[control].errors.required ? `${control}-is-required`
        : this.schoolForm.controls[control].errors.invalidTime ? `${control}-is-not-valid` : `${control}-is-not-valid`;
    }
    return this.translate.instant(`school-management.errors.${errorMSG}`);
  }
  // image upload
  changeProfileImage() {
    const fileUpload = this.fileUploadInput?.nativeElement;
    if (!fileUpload) {
      return;
    }
    // clearing the value first so re-picking the same file still fires `change`
    fileUpload.value = null;
    fileUpload.click();
  }
  onFileSelected(file: FileList) {
    const picked = file?.item(0);
    if (!picked) {
      return;
    }
    // the upload payload and the preview are set together, so they can never diverge
    this.imageFile = picked;
    this.selectedImage = picked;
    const reader = new FileReader();
    reader.onload = (event: any) => {
      this.image = event.target.result;
    };
    reader.readAsDataURL(picked);
  }
  setMapData() {
    this.mapControls = {
      mapPoint: {
        lat: this.schoolObject.lat,
        long: this.schoolObject.long,
      },
      mapaddress: [{
        lat: this.schoolObject.lat,
        long: this.schoolObject.long,
      }],
      mapRoutes: [],
      circles: [
        {
          lat: this.schoolObject.lat,
          long: this.schoolObject.long,
          color: 'yellow',
          radius: this.schoolObject.zone,
        }
      ]
    }
  }
  mapEventHandle(event) {
    switch (event.type) {
      case "mapClicked":
        this.mouseClickedOnMap(event.data);
        break;
    }

  }
  mouseClickedOnMap(data) {
    if (this.mode == "edit") {
      this.schoolObject.lat = data.lat;
      this.schoolObject.long = data.long;
      this.setMapData();
    }
  }
  zoneChanged(event) {
    this.schoolObject.zone = +event.target.value;
    this.setMapData();
  }
  saveSchoolData() {   
    this.amplitudesService.trackEvent('CTA.Save_School_Info',{})
    let body = { ...this.schoolForm.value};
    body["lat"] = this.schoolObject["lat"];
    body["long"] = this.schoolObject["long"];
    body["image"] = this.selectedImage;
    body["school_closing_time"] = this.timeZoneService.convertToSaudiTime(this.schoolForm.value["school_closing_time"] , "HH:mm" , "HH:mm");
    body["last_estimated_pickup_time_for_early_dismissal_requests"] = this.timeZoneService.convertToSaudiTime(this.schoolForm.value["last_estimated_pickup_time_for_early_dismissal_requests"] , "HH:mm" , "HH:mm")
    body.attendance_week_days = [];
    this.weekDays.forEach((e) => {
      if (e.isSelected) {
        body.attendance_week_days.push(e.name);
      }
    });
    // if(this.schoolForm.value['school_closing_time']== '' ||this.schoolForm.value['school_closing_time']== null ){
    //   delete body['school_closing_time']
    // }
    var formData = json2formdata(body);
    this.infoService.updateSchoolInfo(formData).pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)school-info_(f)updateSchoolInfo_(L)264' , res);
    }, err => {
      this.errorHandler(err);
      // this.schoolClosingTimeError=err.error.errors.school_closing_time[0];

    },()=>{
        this.dataService.getSchoolInfo$().pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{ 
          //console.log('(c)school-info_(f)getSchoolInfo_(L)272' , res);         
        this.dataService.setSchoolInfo$(res.filter(school => school.roles.filter(role => role.name === this.loginAs).length));
        this.getSchoolInfo();
      },err=>{},
      ()=>{
        this.toggleMapSearch = false;
        this.mode = "view"
      })
    });
  }

  setOverviewData(errors, staff, students, parents, gates) {
    const staffData = staff.map(val => {
      return {
        count: val.count,
        countFlag: true,
        name: val.name,
        statesFlag: false,
        error: null
      }
    });


    this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)school-info_(f)translate init_(L)296' , res);         
      this.setErrorData(errors);
      this.overviewDataList(this.errorsData, staffData, students, parents, gates)
    });
    this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)school-info_(f)translateOnchange(L)301' , res);         
      this.setErrorData(errors);
      this.overviewDataList(this.errorsData, staffData, students, parents, gates)
    })
  }
  setErrorData(errors) {
    this.errorsData = [{
      count: 0,
      countFlag: false,
      name: this.translate.instant('school-management.school-info.school-info'),
      statesFlag: true,
      error: null
    },
    {
      count: 0,
      countFlag: false,
      name: this.translate.instant('school-management.school-info.staff'),
      statesFlag: true,
      error: null
    },
    {
      count: 0,
      countFlag: false,
      name: this.translate.instant('school-management.school-info.gates'),
      statesFlag: true,
      error: errors['error_gates'] ? this.translate.instant('school-management.errors.gates') : null
    },
    {
      count: 0,
      countFlag: false,
      name: this.translate.instant('school-management.school-info.grades-class'),
      statesFlag: true,
      error: errors['error_grades_classes'] ? this.translate.instant('school-management.errors.grades-classes') : null
    },
    {
      count: 0,
      countFlag: false,
      name: this.translate.instant('school-management.school-info.dismiss-flow'),
      statesFlag: true,
      error: errors['error_flows'] ? this.translate.instant('school-management.errors.flows') : null
    }];
  }
  overviewDataList(errorsData, staffData, students, parents, gates) {
    this.overviewData = [
      {
        header: this.translate.instant('school-management.school-info.school-setup'),
        content: errorsData
      },
      {
        header: this.translate.instant('school-management.school-info.staff-num'),
        content: staffData
      },
      {
        header: this.translate.instant('school-management.school-info.studs-parents'),
        content: [{
          count: students,
          countFlag: true,
          name: this.translate.instant('school-management.school-info.students'),
          statesFlag: false,
          error: null
        },
        {
          count: parents,
          countFlag: true,
          name: this.translate.instant('school-management.school-info.parents'),
          statesFlag: false,
          error: null
        }]
      },
      {
        header: this.translate.instant('school-management.school-info.school-gates'),
        content: [{
          count: gates,
          countFlag: true,
          name: this.translate.instant('school-management.school-info.gates'),
          statesFlag: false,
          error: null
        }]
      }
    ];
  }

  overviewEventHandler(event) {
    switch (event.type) {
      case "errorClicked":
        this.navegateToError(event.row.name);
        break;
    }
  }
  navegateToError(target) {
    switch (target) {
      case "Staff":
        this.router.navigate(['school-management/staff']);
        break;
      case "الفريق الدراسي":
        this.router.navigate(['school-management/staff']);
        break;
      case "Gates":
        this.router.navigate(['school-management/gates']);
        break;
      case "البوابات":
        this.router.navigate(['school-management/gates']);
        break;
      case "Grades & Classes":
        this.router.navigate(['school-management/grades-classes']);
        break;
      case "الصفوف الدراسية والفصول":
        this.router.navigate(['school-management/grades-classes']);
        break;
      case "Dismissal Flow":
        this.router.navigate(['school-management/dismissal-flow']);
        break;
      case "المسارات":
        this.router.navigate(['school-management/dismissal-flow']);
        break;
    }
  }

  resetEndingTime() {
    // check the value of ending time field , if it's empty reset it again so the field reset in the view  
    if ($("#schoolend").val() == '') {
      $("#schoolend").val('')
    }

  }

  resetEarlyPickupTime(){
    // check the value of ending time field , if it's empty reset it again so the field reset in the view  
    if ($("#early-pickup").val() == '') {
     $("#early-pickup").val('')
   }
}
  
/* to validate the form on submit the first time you click on edit 
  , to fix the issue of the button save is disabled cause the email 
  field is set wrong from backend at the creation stage , after the 
  save if there are errors change the update method to be blur 
  so the user can validate on blur and error disapear after changeing 
  the fields with errors */
  onSubmit(form){
    const container = document.querySelector('.info-contain');
    if(form.status == "VALID"){
      this.saveSchoolData();
      form._updateOn = 'submit'
      // this.scrollTopToPosition(container,0);

    }
    else{
      form._updateOn = 'blur'
      this.scrollTopToPosition(container,150);
    }
  }

  scrollTopToPosition(element,offset){
    element.scrollTo({
      top: offset,
      behavior: "smooth"
});
  }

  validateInputNumber(event){
    const el = event.target
    if(el.type == "number" && el.max && el.min ){
      let value = parseInt(el.value)
      el.value = value // for 000 like input cleanup to 0
      let max = parseInt(el.max)
      let min = parseInt(el.min)      
      if ( value > max ) el.value = el.max
      if ( value < min ) el.value = el.min
      if ( el.value =="" || el.value == null || el.value == undefined || Number.isNaN(el.value)){
        el.value = el.min;
      } 
    }
  }

  daySelected(index: number) {
    this.weekDays[index].isSelected = !this.weekDays[index].isSelected;
  }

  setSelectedWeekDays(weekDays:any) {    
  if(weekDays && weekDays.length > 0){
      this.weekDays.forEach((e) => {
        e.isSelected = weekDays?.includes(e.name);
      });
      this.isDaySelected = true;
  }
  else {
    this.isDaySelected = false;
  }
  }

  errorHandler(err: any): void {
    const errorKeys = [
      'school_closing_time',
      'last_estimated_pickup_time_for_early_dismissal_requests'
    ];
    // Iterate through the known error keys
    for (const key of errorKeys) {
      const message = err?.error?.errors?.[key]?.[0];
      if (message) {
        this.errorMsgService.setMessage(message);
        return;
      }
    }
    // Default message
    const defaultMessage = err?.error?.message;
    this.errorMsgService.setMessage(defaultMessage);
  }
  
  
  ngOnDestroy(): void {
  }

}